// ✅ FILE: /firebaseClient.js

import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
};

// Initialize Firebase, creating a new app if one doesn't exist
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();

// Auth & Provider
const auth = getAuth(app);
const googleAuthProvider = new GoogleAuthProvider();

// Firestore
const db = getFirestore(app);

/**
 * Helper to fetch current user's ID token
 * @param {boolean} forceRefresh
 * @returns {Promise<string|null>}
 */
export async function getIdToken(forceRefresh = false) {
  const user = auth.currentUser;
  if (!user || typeof user.getIdToken !== 'function') return null;
  return user.getIdToken(forceRefresh);
}

export { app, auth, db, googleAuthProvider };
